module.exports = "/_next/static/images/bgImageHeader-dc9f0aa290a86ac02c800e2a5d14f439.webp";